import {useState} from 'react'
import * as Yup from 'yup'
import clsx from 'clsx'
import {Link, useParams, useNavigate} from 'react-router-dom'
import {Formik, Form, Field, ErrorMessage} from 'formik'
import {toast} from 'react-toastify'
import api_instance from '../../../../Helpers/Api_instance'
import {KTIcon} from '../../../../Ihouse/helpers'

const initialValues = {
  password: '',
  confirmPass: '',
}
const ResetPasswordSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'password must be at least 6 characters')
    .required('password is required'),
  confirmPass: Yup.string()
    .oneOf([Yup.ref('password'), ''], 'Passwords must match')
    .required('Confirm password is required'),
})

export function ResetPassword() {
  const [loading, setLoading] = useState(false)
  const [hasErrors, setHasErrors] = useState<boolean | undefined>(undefined)
  const [showPass, setShowPass] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const navigate = useNavigate()
  const {id} = useParams()
  const submitHandler = async (values, {resetForm}) => {
    try {
      setHasErrors(false)
      const res = await api_instance.post(`/auth/resetforgot?token=${id}`, values)
      if (res && res.data) {
        setHasErrors(false)
        navigate('/auth/login')
      }
    } catch (error: any) {
      console.log(error)
      setHasErrors(true)
      resetForm()
      toast.error('Unable reset password !')
    }
  }
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={submitHandler}
      validationSchema={ResetPasswordSchema}
    >
      {() => (
        <Form
          className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
          noValidate
          id='kt_login_password_reset_form'
        >
          <div className='text-center mb-10'>
            <h1 className='text-dark fw-bolder mb-3'>Reset Password ?</h1>

            <div className='text-gray-500 fw-semibold fs-6'>
              Enter your password to reset your password.
            </div>
          </div>

          {hasErrors === true && (
            <div className='mb-lg-15 alert alert-danger'>
              <div className='alert-text font-weight-bold'>
                Sorry, looks like there are some errors detected, please try again.
              </div>
            </div>
          )}

          {hasErrors === false && (
            <div className='mb-10 bg-light-info p-8 rounded'>
              <div className='text-info'>
                Your Password Reset is successfull, You can Login Now.
              </div>
            </div>
          )}

          <div className='fv-row mb-8 position-relative'>
            <label className='form-label fw-bolder text-gray-900 fs-6'>Password</label>
            <div className='position-relative'>
              <Field
                type={showPass ? 'text' : 'password'}
                placeholder='New Password'
                autoComplete='off'
                name='password'
                className={clsx('form-control bg-transparent pe-10')}
              />
              <button
                type='button'
                style={{
                  backgroundColor: 'transparent',
                  position: 'absolute',
                  top: '50%',
                  right: '0.75rem',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  border: 0,
                }}
                onClick={() => setShowPass((prev) => !prev)}
              >
                <KTIcon iconName={showPass ? 'eye-slash' : 'eye'} className='fs-2' />
              </button>
            </div>
            <ErrorMessage name='password' component='div' className='text-sm text-danger' />
          </div>

          <div className='fv-row mb-8 position-relative'>
            <label className='form-label fw-bolder text-gray-900 fs-6'>Confirm Password</label>
            <div className='position-relative'>
              <Field
                type={showConfirm ? 'text' : 'password'}
                placeholder='Confirm Password'
                autoComplete='off'
                name='confirmPass'
                className={clsx('form-control bg-transparent pe-10')}
              />
              <button
                type='button'
                style={{
                  backgroundColor: 'transparent',
                  position: 'absolute',
                  top: '50%',
                  right: '0.75rem',
                  transform: 'translateY(-50%)',
                  zIndex: 1,
                  border: 0,
                }}
                onClick={() => setShowConfirm((prev) => !prev)}
              >
                <KTIcon iconName={showConfirm ? 'eye-slash' : 'eye'} className='fs-2' />
              </button>
            </div>
            <ErrorMessage name='confirmPass' component='div' className='text-sm text-danger' />
          </div>
          <div className='d-flex flex-wrap justify-content-center pb-lg-0'>
            <button type='submit' id='kt_password_reset_submit' className='btn btn-primary me-4'>
              <span className='indicator-label'>Submit</span>
              {loading && (
                <span className='indicator-progress'>
                  Please wait...
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                </span>
              )}
            </button>
            <Link to='/auth/login'>
              <button
                type='button'
                id='kt_login_password_reset_form_cancel_button'
                className='btn btn-light'
              >
                Cancel
              </button>
            </Link>
          </div>
        </Form>
      )}
    </Formik>
  )
}
